import type {
  GetBulkImportResponse,
  HeaderMappings,
  PostBulkImportResponse,
  PutBulkImportResponse,
} from '@/modules/Settings';
import type Developer from '@/types/api/Developer';
import { createApiRequest } from '@/utils/services';

type PostBulkImportRequest = {
  method: string;
  data: {
    createdBy: Developer;
    ownerOrgId: string;
    presignedPostUrl: string;
  };
  path: string;
  throwErrors: boolean;
};

type PutBulkImportRequest = {
  method: string;
  data: {
    ownerOrgId: string;
    updatedBy: Developer;
  };
  path: string;
  throwErrors: boolean;
};

export function postBulkImport(
  presignedPostUrl: string,
  createdBy: Developer,
  ownerOrgId: string,
) {
  return createApiRequest<PostBulkImportRequest, PostBulkImportResponse>({
    method: 'post',
    path: 'bulk-imports',
    data: {
      createdBy,
      ownerOrgId,
      presignedPostUrl,
    },
    throwErrors: true,
  });
}

export function putBulkImport<Data>({
  bulkImportId,
  data,
  ownerOrgId,
  updatedBy,
  headerMappings,
}: {
  bulkImportId: string;
  data: Data;
  ownerOrgId: string;
  updatedBy: Developer;
  headerMappings: HeaderMappings;
}) {
  return createApiRequest<PutBulkImportRequest, PutBulkImportResponse>({
    method: 'put',
    path: `bulk-imports/${bulkImportId}`,
    data: {
      ownerOrgId,
      updatedBy,
      ...(Object.keys(headerMappings).length && {
        headerMappings,
      }),
      ...data,
    },
    throwErrors: true,
  });
}

type GetBulkImportRequest = {
  method: string;
  path: string;
  throwErrors: boolean;
};

export function getBulkImport(bulkImportId: string) {
  return createApiRequest<GetBulkImportRequest, GetBulkImportResponse>({
    method: 'get',
    path: `bulk-imports/${bulkImportId}`,
    throwErrors: true,
  });
}

export default {
  getBulkImport,
  postBulkImport,
  putBulkImport,
};
